import { AppLanguage } from './i18n.models';

const en = {
  'app.brand': 'Clinic Platform',
  'app.shellTitle': 'Operational Shell',
  'app.logout': 'Logout',
  'app.language': 'Language',

  'nav.appointments': 'Appointments',
  'nav.slots': 'Slots',
  'nav.devices': 'Devices',
  'nav.downtime': 'Downtime',
  'nav.specialistDowntime': 'Specialist Downtime',
  'nav.rescheduleProposals': 'Reschedule Proposals',
  'nav.appointmentChangeRequests': 'Change Requests',
  'nav.notificationQueue': 'Notification Queue',
  'nav.notificationTemplates': 'Notification Templates',
  'nav.notification': 'Notification',
  'nav.users': 'User Management',
  'nav.procedureTypes': 'Procedure Types',
  'nav.companies': 'Companies',
  'nav.myProfile': 'My Profile',
  'nav.settings': 'Settings',
  'nav.clinics': 'Clinics',
  'nav.globalSettings': 'Global Settings',
  'nav.dataRetention': 'Data Retention',
  'nav.security': 'Security',
  'nav.connectors': 'Connectors',

  'auth.signInSubtitle': 'Sign in to access the operational shell',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.enterEmail': 'Enter email',
  'auth.enterPassword': 'Enter password',
  'auth.signIn': 'Sign in',
  'auth.signingIn': 'Signing in...',
  'auth.loginFailed': 'Login failed. Please check your credentials.',
  'auth.loginTenantUrlRequired': 'Open the company login URL to continue sign-in.',
  'auth.2faCode': '2FA Code',
  'auth.2faCodePlaceholder': 'Enter 6-digit code',
  'auth.trustDevice': 'Trust this device (skip 2FA next time)',
  'auth.createClientAccount': 'Create client account',
  'auth.registerTitle': 'Client Registration',
  'auth.registerSubtitle': 'Create your account in company',
  'auth.register': 'Register',
  'auth.registering': 'Registering...',
  'auth.confirmPassword': 'Confirm password',
  'auth.backToLogin': 'Back to login',
  'auth.passwordMismatch': 'Passwords do not match.',
  'auth.registrationFailed': 'Registration failed. Please try again.',
  'auth.registrationEmailExists': 'A client with this email already exists in this company.',
  'auth.registrationSuccess': 'Registration successful. Check your email to verify account.',
  'auth.loginEmailVerificationRequired': 'Email is not verified yet. Check your inbox and verify account.',
  'auth.verifyEmailTitle': 'Email Verification',
  'auth.verifyEmailLoading': 'Verifying your email...',
  'auth.verifyEmailSuccess': 'Email verified. You can sign in now.',
  'auth.verifyEmailInvalid': 'Verification link is invalid.',
  'auth.verifyEmailFailed': 'Verification failed or link expired.',
  'auth.registrationUnavailable': 'Registration is available only in company URL context.',
  'auth.inviteAcceptTitle': 'Finish invited account setup',
  'auth.inviteAcceptSubtitle': 'Set your password to activate the invited client account.',
  'auth.staffInviteAcceptSubtitle': 'Set your password to activate the invited staff account.',
  'auth.inviteAcceptLoading': 'Loading invite details...',
  'auth.inviteAcceptSubmit': 'Activate account',
  'auth.inviteAcceptSubmitting': 'Activating account...',
  'auth.inviteAcceptSuccess': 'Account activated. You can sign in now.',
  'auth.inviteAcceptFailed': 'Invite activation failed. Please try again.',
  'auth.inviteMetaFailed': 'Could not load invite details.',
  'auth.inviteInvalid': 'Invite link is invalid.',
  'auth.inviteExpired': 'Invite link has expired.',
  'auth.inviteConflict': 'This invite email is already used by another account.',
  'auth.inviteExpiresAt': 'Invite expires at',
  Company: 'Company',
  'Select company': 'Select company',
  'Loading companies...': 'Loading companies...',
  'System admin login uses automatic company context.': 'System admin login uses automatic company context.',
  'error.generic': 'Request failed. Please try again.',
  'error.network': 'Network error. Check connection and try again.',
  'error.forbiddenResource': 'You do not have permission to view this data.',
  'error.settingsCompanyContextRequired': 'Select a company in the header to view settings data.',
  'error.forbiddenAppointmentCreate': 'You do not have permission to create appointments.',
  'error.forbiddenAppointmentAction': 'You do not have permission to update appointments.',
  'error.forbiddenAppointmentsList': 'You do not have permission to view appointments.',
  'error.forbiddenDowntimeCreate': 'You do not have permission to create downtime requests.',
  'error.forbiddenDowntimeAction': 'You do not have permission to manage downtime records.',
  'error.forbiddenDowntimeList': 'You do not have permission to view downtime records.',
  'error.forbiddenRescheduleProposalAction': 'You do not have permission to process reschedule proposals.',
  'error.forbiddenRescheduleProposalsList': 'You do not have permission to view reschedule proposals.',
  'error.forbiddenSlotsList': 'You do not have permission to view slots.',
  'error.forbiddenNotificationQueueList': 'You do not have permission to view notification queue.',
  'error.forbiddenUserManagement': 'You do not have permission to manage users.',
  'error.appointmentActionFailed': 'Failed to update appointment status.',
  'error.appointmentClientTimeOverlap':
    'This client already has an appointment that overlaps this time. Choose another time or update the existing appointment.',
  'error.appointmentChangeRequestDuplicatePending':
    'An identical appointment change request is already pending for this appointment.',
  'error.downtimeActionFailed': 'Failed to update downtime record.',
  'error.downtimeStartSlotGrid': 'Downtime start time must align to the 15-minute slot grid.',
  'error.downtimeEndSlotGrid': 'Expected repair time must align to the 15-minute slot grid.',
  'error.downtimeEndAfterStart': 'Expected repair time must be later than start time.',
  'error.downtimeInvalidTimeRange': 'Downtime time range is invalid.',
  'error.rescheduleProposalActionFailed': 'Failed to process reschedule proposal.',
  'error.userCreateFailed': 'Failed to create user.',
  'error.userListLoadFailed': 'Failed to load users.',

  'common.loading': 'Loading...',
  'common.noData': 'No data',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.close': 'Close',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.saving': 'Saving...',
  'common.creating': 'Creating...',
  'users.createClient': 'Create client',
  'users.editUser': 'Edit user',
  'users.clientQuickView': 'Client Quick View',
  'users.userProfile': 'User profile',
  'users.error.clientCreateFailed': 'Failed to create client.',
  'users.error.clientContactRequired': 'Add email or phone before creating a client.',
  'users.error.clientEmailConflict': 'A client with this email already exists.',
  'users.error.clientResolveFailed': 'Failed to resolve client record.',
  'users.error.fullNameRequired': 'Full name is required.',
  'security.page.title': 'Security',
  'security.page.subtitle': 'Two-factor authentication settings',
  'security.2fa.title': 'Two-Factor Authentication (TOTP)',
  'security.loading': 'Loading security status...',
  'security.required': 'Required',
  'security.enabled': 'Enabled',
  'security.preparing': 'Preparing...',
  'security.setup': 'Setup 2FA',
  'security.scanAndConfirm': 'Scan QR and confirm',
  'security.secret': 'Secret',
  'security.qrAlt': '2FA QR code',
  'security.otpUri': 'OTP URI',
  'security.code': '2FA code',
  'security.verifying': 'Verifying...',
  'security.enable': 'Enable 2FA',
  'security.recoveryCodes': 'Recovery codes',
  'security.recoveryHint': 'Store these codes securely. Each code can be used once.',
  'security.disableCode': 'Enter 2FA code to disable',
  'security.disabling': 'Disabling...',
  'security.disable': 'Disable 2FA',
  'security.mandatoryNoDisable': '2FA is mandatory for your role and cannot be disabled.',
  'security.error.setupInit': 'Failed to initialize 2FA setup.',
  'security.error.invalidCode': 'Invalid 2FA code.',
  'security.error.disable': 'Unable to disable 2FA.',
  'security.error.loadStatus': 'Failed to load 2FA status.',
  'security.success.enabled': '2FA has been enabled.',
  'security.success.disabled': '2FA has been disabled.',
  'security.policy.title': '2FA Policy',
  'security.policy.description': 'Select roles that must always use 2FA.',
  'security.policy.title.system': 'System Default 2FA Policy',
  'security.policy.title.company': 'Company 2FA Policy',
  'security.policy.description.system': 'These defaults are inherited by companies unless overridden by company admin.',
  'security.policy.description.company': 'Override mandatory 2FA roles for your company.',
  'security.policy.source': 'Source',
  'security.policy.source.override': 'Company override',
  'security.policy.source.inherited': 'Inherited from system defaults',
  'security.policy.loading': 'Loading policy...',
  'security.policy.noEditableRoles': 'No editable roles available in this context.',
  'security.policy.saving': 'Saving...',
  'security.policy.save': 'Save Policy',
  'security.policy.useSystemDefaults': 'Use System Defaults',
  'security.policy.success.updated': 'Policy updated.',
  'security.policy.success.inherited': 'Policy switched to inherited defaults.',
  'security.policy.error.update': 'Failed to update policy.',
  'security.policy.error.load': 'Failed to load company 2FA policy.',
  'security.policy.error.inherited': 'Failed to switch policy to inherited defaults.',
  'security.guard.modal.title': '2FA Setup Required',
  'security.guard.modal.message':
    'Two-factor authentication setup is required. Complete setup in Security before using other sections.',
  'security.guard.modal.confirm': 'Go to Security',
  'telegram.page.title': 'Connectors',
  'telegram.page.subtitle': 'External channels for messaging, linking, and operational actions',
  'telegram.settings.title': 'Tenant Telegram Bot',
  'telegram.settings.description': 'Configure the company-owned bot token and webhook used by Telegram notifications.',
  'telegram.settings.bot': 'Bot',
  'telegram.settings.token': 'Token',
  'telegram.settings.tokenConfigured': 'Configured',
  'telegram.settings.tokenMissing': 'Missing',
  'telegram.settings.webhook': 'Webhook',
  'telegram.settings.webhookConfigured': 'Configured',
  'telegram.settings.webhookMissing': 'Missing',
  'telegram.settings.lastValidated': 'Last validated',
  'telegram.settings.botToken': 'Bot token',
  'telegram.settings.keepExistingToken': 'Leave empty to keep existing token',
  'telegram.settings.active': 'Telegram active',
  'telegram.settings.save': 'Save Telegram settings',
  'telegram.settings.validate': 'Validate bot',
  'telegram.settings.publicBaseUrlOverride': 'Public base URL override',
  'telegram.settings.configureWebhook': 'Configure webhook',
  'telegram.settings.webhookSecretNote': 'Webhook URL contains a secret path. Do not share it outside admin context.',
  'telegram.status.active': 'Active',
  'telegram.status.inactive': 'Inactive',
  'telegram.saving': 'Saving...',
  'telegram.validating': 'Validating...',
  'telegram.configuringWebhook': 'Configuring...',
  'telegram.link.title': 'My Telegram Link',
  'telegram.link.description': 'Connect your staff account to Telegram before staff notifications are enabled.',
  'telegram.link.clientTitle': 'My Telegram',
  'telegram.link.clientDescription': 'Connect Telegram to receive appointment messages from the clinic.',
  'telegram.link.connected': 'Connected',
  'telegram.link.notConnected': 'Not connected',
  'telegram.link.account': 'Telegram account',
  'telegram.link.linkedAt': 'Linked at',
  'telegram.link.deepLink': 'Connection link',
  'telegram.link.expiresAt': 'Expires at',
  'telegram.link.connect': 'Connect Telegram',
  'telegram.link.preparing': 'Preparing...',
  'telegram.link.copy': 'Copy link',
  'telegram.link.copying': 'Copying...',
  'telegram.link.revoke': 'Revoke link',
  'telegram.link.revoking': 'Revoking...',
  'telegram.error.webhookNotConfigured':
    'Telegram webhook is not configured yet. Ask an administrator to configure the tenant webhook first.',
  'common.actions': 'Actions',
  'common.status': 'Status',
  'common.id': 'ID',
  'Clinic ID': 'Clinic ID',
  'Device ID': 'Device ID',
  'Client ID': 'Client ID',
  'Procedure Type': 'Procedure Type',
  'First Slot ID': 'First Slot ID',
  'Specialist User ID (optional)': 'Specialist User ID (optional)',
  'Select procedure': 'Select procedure',
  'Confirmation required': 'Confirmation required',
  'Computed slot count:': 'Computed slot count:',
  'Computed slots:': 'Computed slots:',
  'Device (optional override)': 'Device (optional override)',
  'Unable to build contiguous slot block.': 'Unable to build contiguous slot block.',
  'Create appointment': 'Create appointment',
  'Edit appointment': 'Edit appointment',
  'Update appointment': 'Update appointment',
  'Updating...': 'Updating...',
  'Update pending request before confirmation': 'Update pending request before confirmation',
  'Lock client time changes (client can only accept or cancel)':
    'Lock client time changes (client can only accept or cancel)',
  'Create downtime': 'Create downtime',
  'Back to edit': 'Back to edit',
  All: 'All',
  'Date From': 'Date From',
  'Date To': 'Date To',
  'Next 14 days': 'Next 14 days',
  'Next 30 days': 'Next 30 days',
  'This week': 'This week',
  'This month': 'This month',
  'Apply Filters': 'Apply Filters',
  Reset: 'Reset',
  'Work Date': 'Work Date',
  'Day Start': 'Day Start',
  'Day End': 'Day End',
  'Generating...': 'Generating...',
  'Event Type': 'Event Type',
  'Entity Type': 'Entity Type',
  'Entity ID': 'Entity ID',
  'Recipient Email': 'Recipient Email',
  'Updated At': 'Updated At',
  'Request Note': 'Request Note',
  'Review Note': 'Review Note',
  'Optional note': 'Optional note',
  'Change request history': 'Change request history',
  'clientReliability.title': 'Client Reliability',
  'clientReliability.titleShort': 'Reliability',
  'clientReliability.historyTitle': 'Reliability History',
  'clientReliability.manualAdjustmentTitle': 'Manual Adjustment',
  'clientReliability.manualDelta': 'Adjustment (%)',
  'clientReliability.manualReason': 'Reason / Comment',
  'clientReliability.manualReasonRequired': 'Reason is required by company policy',
  'clientReliability.manualSubmit': 'Apply adjustment',
  'clientReliability.label.reliable': 'Reliable',
  'clientReliability.label.watch': 'Watch',
  'clientReliability.label.risk': 'Risk',
  'clientReliability.event.lateCancel': 'Late cancellation',
  'clientReliability.event.noShow': 'No-show',
  'clientReliability.event.lateArrival': 'Late arrival',
  'clientReliability.event.clientReschedule': 'Client reschedule',
  'clientReliability.event.attendedOnTime': 'Attended on time',
  'clientReliability.event.manualAdjustment': 'Manual adjustment',
  'clientReliability.manualAdjustmentSuccess': 'Reliability score updated.',
  'clientReliability.manualAdjustmentError': 'Failed to adjust client reliability',
  'clientReliability.churnStep': 'Reschedule step',
  Operations: 'Operations',
  Mail: 'Mail',
  Branding: 'Branding',
  Global: 'Global',
  'settings.rating.tab': 'Rating',
  'settings.rating.title': 'Rating Settings',
  'settings.rating.description':
    'These weights define internal CRM reliability scoring for clients. They do not affect client-facing feedback.',
  'settings.rating.lateCancelPenalty': 'Late cancel penalty (%)',
  'settings.rating.lateCancelWindowHours': 'Late cancel window (hours)',
  'settings.rating.noShowPenalty': 'No-show penalty (%)',
  'settings.rating.lateArrivalPenalty': 'Late arrival penalty (%)',
  'settings.rating.firstClientReschedulePenalty': 'First client reschedule penalty (%)',
  'settings.rating.secondClientReschedulePenalty': 'Second client reschedule penalty (%)',
  'settings.rating.thirdPlusClientReschedulePenalty': 'Third+ client reschedule penalty (%)',
  'settings.rating.attendedOnTimeBonus': 'Attended on-time bonus (%)',
  'settings.rating.watchThreshold': 'Watch threshold (%)',
  'settings.rating.riskThreshold': 'Risk threshold (%)',
  'settings.rating.manualAdjustmentAllowed': 'Allow manual adjustment',
  'settings.rating.manualAdjustmentReasonRequired': 'Require reason for manual adjustment',
  'settings.rating.save': 'Save rating settings',
  'settings.rating.success.saved': 'Rating settings saved',
  'settings.rating.error.thresholdOrder': 'Risk threshold cannot be higher than watch threshold.',
  'settings.rating.context.company': 'Editing internal client reliability policy for your company.',
  'settings.rating.context.systemSelectedCompany':
    'Editing internal client reliability policy for the selected company.',
  'settings.rating.context.systemSelectCompany': 'Select a company to edit internal client reliability policy.',
  'Reviewed At': 'Reviewed At',
  'Requested vs Current': 'Requested vs Current',
  Proposal: 'Proposal',
  'Old Primary Slot': 'Old Primary Slot',
  'New Primary Slot': 'New Primary Slot',
  'Select a proposal to view details': 'Select a proposal to view details',
  'Expected Repair Until': 'Expected Repair Until',
  'Actual End Time': 'Actual End Time',
  'Affected Appointments': 'Affected Appointments',
  Edit: 'Edit',
  Delete: 'Delete',
  Status: 'Status',
  Actions: 'Actions',
  Enabled: 'Enabled',
  Disabled: 'Disabled',
  Enable: 'Enable',
  Disable: 'Disable',

  'status.pending': 'Pending',
  'status.pendingApproval': 'Pending Approval',
  'status.pendingConfirmation': 'Pending',
  'status.confirmed': 'Confirmed',
  'status.completed': 'Completed',
  'status.cancelled': 'Cancelled',
  'status.noShow': 'No-show',
  'status.rescheduleRequired': 'Reschedule Required',
  'appointments.tabs.schedule': 'Schedule',
  'appointments.tabs.reschedule': 'Reschedule',
  'appointments.tabs.clientMap': 'Client Map',
  'appointments.tabs.fluidCapacity': 'Fluid Capacity',
  'appointments.tabs.capacityStage': 'Capacity Stage',
  'appointments.tabs.capacityMatrix': 'Capacity Matrix',
  'appointments.tabs.changeRequests': 'Change Requests',
  'appointments.filters.allStatuses': 'All statuses',
  'appointments.filters.sort': 'Sort',
  'appointments.sort.createdAtDesc': 'Newest created',
  'appointments.sort.createdAtAsc': 'Oldest created',
  'appointments.sort.startAtAsc': 'Soonest appointment',
  'appointments.sort.startAtDesc': 'Latest appointment',
  'notificationQueue.sort.createdAtDesc': 'Newest created',
  'notificationQueue.sort.createdAtAsc': 'Oldest created',
  'notificationQueue.sort.updatedAtDesc': 'Recently updated',
  'notificationQueue.sort.updatedAtAsc': 'Oldest updated',
  'slots.sort.startAtAsc': 'Earliest slot',
  'slots.sort.startAtDesc': 'Latest slot',
  'slots.sort.createdAtDesc': 'Newest created',
  'slots.sort.createdAtAsc': 'Oldest created',
  'status.accepted': 'Accepted',
  'status.approved': 'Approved',
  'status.rejected': 'Rejected',
  'status.expired': 'Expired',
  'status.revoked': 'Revoked',
  'status.available': 'Available',
  'status.past': 'Past',
  'status.reserved': 'Reserved',
  'status.blocked': 'Blocked',
  'status.processing': 'Processing',
  'status.sent': 'Sent',
  'status.failed': 'Failed',
  'status.scheduled': 'Scheduled',
  'status.active': 'Active',
  'status.resolved': 'Resolved',

  'action.confirm': 'Confirm',
  'action.checkIn': 'Check in',
  'action.finish': 'Finish',
  'action.noShow': 'Mark no-show',
  'action.edit': 'Edit',
  'action.complete': 'Complete',
  'action.cancel': 'Cancel',
  'action.approve': 'Approve',
  'action.accept': 'Accept',
  'action.reject': 'Reject',
  'action.createAppointment': 'Create Appointment',
  'Auto (from slot)': 'Auto (from slot)',
  'Select first slot': 'Select first slot',
  'Manual device override': 'Manual device override',
  Table: 'Table',
  Calendar: 'Calendar',
  'slots.previousDay': 'Previous Day',
  'slots.today': 'Today',
  'slots.nextDay': 'Next Day',
  'slots.selectedDay': 'Selected Day',
  'slots.allDevices': 'All devices',
  'slots.allSpecialists': 'All specialists',
  'slots.staffSummary.available': 'Available',
  'slots.staffSummary.reserved': 'Reserved',
  'slots.staffSummary.blocked': 'Blocked',
  'slots.staffSummary.completed': 'Completed',
  'slots.staffSummary.specialists': 'Specialists',
  'slots.staffSummary.devices': 'Devices',
  'slots.staffSummary.capacityWindows': 'Capacity windows',
  'slots.staffSummary.hardUnavailable': 'Hard unavailable',
  'slots.staffSummary.specialistCapacity': 'Specialist capacity',
  'slots.staffSummary.deviceCapacity': 'Device capacity',

  Appointments: 'Appointments',
  Slots: 'Slots',
  Downtime: 'Downtime',
  'Reschedule Proposals': 'Reschedule Proposals',
  'Notification Queue': 'Notification Queue',
  'Device Downtime': 'Device Downtime',
  'Create Appointment': 'Create Appointment',
  'Create Device Downtime': 'Create Device Downtime',
  'User Management': 'User Management',

  'Operational view of current appointments': 'Operational view of current appointments',
  'Operational view of slot inventory': 'Operational view of slot inventory',
  'Appointments affected by downtime': 'Appointments affected by downtime',
  'Outbox and delivery status overview': 'Outbox and delivery status overview',
  'Manual operational creation form': 'Manual operational creation form',
  'Manual maintenance and outage registration': 'Manual maintenance and outage registration',
  'Create test users for role and guard validation': 'Create test users for role and guard validation',

  'Loading appointments...': 'Loading appointments...',
  'Loading slots...': 'Loading slots...',
  'Loading proposals...': 'Loading proposals...',
  'Loading notification queue...': 'Loading notification queue...',
  'Loading downtime items...': 'Loading downtime items...',
  'Loading device downtime...': 'Loading device downtime...',
  'Loading users...': 'Loading users...',
  'Loading profile...': 'Loading profile...',

  'Failed to load appointments': 'Failed to load appointments',
  'Failed to load slots': 'Failed to load slots',
  'Failed to load proposals': 'Failed to load proposals',
  'Failed to load notification queue': 'Failed to load notification queue',
  'Failed to load downtime items': 'Failed to load downtime items',
  'Failed to load device downtime': 'Failed to load device downtime',
  'Failed to load users': 'Failed to load users',
  'Failed to load profile': 'Failed to load profile',

  'No appointments found': 'No appointments found',
  'No slots found': 'No slots found',
  'No proposals found': 'No proposals found',
  'No notification jobs found': 'No notification jobs found',
  'No downtime records found': 'No downtime records found',
  'No users found': 'No users found',
  'Profile not found': 'Profile not found',

  'The appointments list is currently empty.': 'The appointments list is currently empty.',
  'No slots matched the current filters.': 'No slots matched the current filters.',
  'No proposals matched the current filters.': 'No proposals matched the current filters.',
  'No notification queue jobs for current filters.': 'No notification queue jobs for current filters.',
  'No downtime records for current filters.': 'No downtime records for current filters.',
  'The slot list is currently empty for the selected filter set.': 'The slot list is currently empty for the selected filter set.',
  'The notification queue is currently empty.': 'The notification queue is currently empty.',
  'The downtime list is currently empty.': 'The downtime list is currently empty.',
  'Currently there are no reschedule proposals.': 'Currently there are no reschedule proposals.',
  'Operational view of maintenance and outage windows': 'Operational view of maintenance and outage windows',
  'No users available for this company yet.': 'No users available for this company yet.',
  Retry: 'Retry',
  'Load more': 'Load more',
  'Loading more...': 'Loading more...',
  'downtime.pendingApprovals': 'Pending approvals',
  'No client profile is linked to your account yet.': 'No client profile is linked to your account yet.',
  'My Profile': 'My Profile',
  'Personal account information': 'Personal account information',
  'Full Name': 'Full Name',
  Phone: 'Phone',
  'Birth Date': 'Birth Date',
  Notes: 'Notes',

  Clinic: 'Clinic',
  Client: 'Client',
  Procedure: 'Procedure',
  Device: 'Device',
  Specialist: 'Specialist',
  'Primary Slot': 'Primary Slot',
  'Confirmation Required': 'Confirmation Required',
  'Confirmed At': 'Confirmed At',
  Source: 'Source',
  Appointment: 'Appointment',
  'Old Slot': 'Old Slot',
  'New Slot': 'New Slot',
  Reason: 'Reason',
  Created: 'Created',
  'Start Time': 'Start Time',
  'End Time': 'End Time',
  Role: 'Role',
  Active: 'Active',
  Inactive: 'Inactive',
  'Create user': 'Create user',
  'role.manager': 'Manager',
  'role.technician': 'Technician',
  'role.specialist': 'Specialist',
  'role.reception': 'Reception',
  'role.client': 'Client',
  'role.company_admin': 'Company Admin',
  'role.system_admin': 'System Admin'
} as const;

const ro: Record<string, string> = {
  'app.brand': 'Platforma Clinicii',
  'app.shellTitle': 'Panou Operațional',
  'app.logout': 'Ieșire',
  'app.language': 'Limbă',

  'nav.appointments': 'Programări',
  'nav.slots': 'Intervale',
  'nav.devices': 'Dispozitive',
  'nav.downtime': 'Ne-funcționare',
  'nav.specialistDowntime': 'Ne-funcționare specialist',
  'nav.rescheduleProposals': 'Propuneri de reprogramare',
  'nav.appointmentChangeRequests': 'Cereri de modificare',
  'nav.notificationQueue': 'Coada notificărilor',
  'nav.notificationTemplates': 'Șabloane notificări',
  'nav.notification': 'Notificări',
  'nav.users': 'Administrare utilizatori',
  'nav.procedureTypes': 'Tipuri proceduri',
  'nav.companies': 'Companii',
  'nav.myProfile': 'Profilul meu',
  'nav.settings': 'Setări',
  'nav.clinics': 'Clinici',
  'nav.globalSettings': 'Setări globale',
  'nav.dataRetention': 'Retenție date',
  'nav.security': 'Securitate',
  'nav.connectors': 'Conectori',

  'auth.signInSubtitle': 'Autentifică-te pentru a accesa panoul operațional',
  'auth.email': 'Email',
  'auth.password': 'Parolă',
  'auth.enterEmail': 'Introdu email',
  'auth.enterPassword': 'Introdu parola',
  'auth.signIn': 'Autentificare',
  'auth.signingIn': 'Se autentifică...',
  'auth.loginFailed': 'Autentificare eșuată. Verifică datele de acces.',
  'auth.loginTenantUrlRequired': 'Deschide URL-ul de login al companiei pentru a continua autentificarea.',
  'auth.2faCode': 'Cod 2FA',
  'auth.2faCodePlaceholder': 'Introdu codul din 6 cifre',
  'auth.trustDevice': 'Ai încredere în acest dispozitiv (omite 2FA data viitoare)',
  'auth.createClientAccount': 'Creează cont client',
  'auth.registerTitle': 'Înregistrare client',
  'auth.registerSubtitle': 'Creează-ți contul în compania',
  'auth.register': 'Înregistrează-te',
  'auth.registering': 'Se înregistrează...',
  'auth.confirmPassword': 'Confirmă parola',
  'auth.backToLogin': 'Înapoi la login',
  'auth.passwordMismatch': 'Parolele nu coincid.',
  'auth.registrationFailed': 'Înregistrarea a eșuat. Încearcă din nou.',
  'auth.registrationEmailExists': 'Un client cu acest email există deja în această companie.',
  'auth.registrationSuccess': 'Înregistrare reușită. Verifică emailul pentru activarea contului.',
  'auth.loginEmailVerificationRequired': 'Emailul nu este încă verificat. Verifică inbox-ul și activează contul.',
  'auth.verifyEmailTitle': 'Verificare Email',
  'auth.verifyEmailLoading': 'Se verifică emailul...',
  'auth.verifyEmailSuccess': 'Email verificat. Acum te poți autentifica.',
  'auth.verifyEmailInvalid': 'Link-ul de verificare este invalid.',
  'auth.verifyEmailFailed': 'Verificarea a eșuat sau link-ul a expirat.',
  'auth.registrationUnavailable': 'Înregistrarea este disponibilă doar în contextul URL al companiei.',
  'auth.inviteAcceptTitle': 'Finalizează activarea contului invitat',
  'auth.inviteAcceptSubtitle': 'Setează parola pentru a activa contul client invitat.',
  'auth.staffInviteAcceptSubtitle': 'Setează parola pentru a activa contul invitat al angajatului.',
  'auth.inviteAcceptLoading': 'Se încarcă detaliile invitației...',
  'auth.inviteAcceptSubmit': 'Activează contul',
  'auth.inviteAcceptSubmitting': 'Se activează contul...',
  'auth.inviteAcceptSuccess': 'Cont activat. Acum te poți autentifica.',
  'auth.inviteAcceptFailed': 'Activarea invitației a eșuat. Încearcă din nou.',
  'auth.inviteMetaFailed': 'Detaliile invitației nu au putut fi încărcate.',
  'auth.inviteInvalid': 'Link-ul invitației este invalid.',
  'auth.inviteExpired': 'Link-ul invitației a expirat.',
  'auth.inviteConflict': 'Emailul acestei invitații este deja folosit de alt cont.',
  'auth.inviteExpiresAt': 'Invitația expiră la',
  Company: 'Companie',
  'Select company': 'Selectează compania',
  'Loading companies...': 'Se încarcă companiile...',
  'System admin login uses automatic company context.': 'Autentificarea system admin folosește automat contextul companiei.',
  'error.generic': 'Cererea a eșuat. Încearcă din nou.',
  'error.network': 'Eroare de rețea. Verifică conexiunea și încearcă din nou.',
  'error.forbiddenResource': 'Nu ai permisiunea de a vedea aceste date.',
  'error.settingsCompanyContextRequired': 'Selectează o companie din antet pentru a vedea setările.',
  'error.forbiddenAppointmentCreate': 'Nu ai permisiunea de a crea programări.',
  'error.forbiddenAppointmentAction': 'Nu ai permisiunea de a actualiza programările.',
  'error.forbiddenAppointmentsList': 'Nu ai permisiunea de a vedea programările.',
  'error.forbiddenDowntimeCreate': 'Nu ai permisiunea de a crea cereri de ne-funcționare.',
  'error.forbiddenDowntimeAction': 'Nu ai permisiunea de a gestiona înregistrări de ne-funcționare.',
  'error.forbiddenDowntimeList': 'Nu ai permisiunea de a vedea înregistrări de ne-funcționare.',
  'error.forbiddenRescheduleProposalAction': 'Nu ai permisiunea de a procesa propuneri de reprogramare.',
  'error.forbiddenRescheduleProposalsList': 'Nu ai permisiunea de a vedea propuneri de reprogramare.',
  'error.forbiddenSlotsList': 'Nu ai permisiunea de a vedea intervalele.',
  'error.forbiddenNotificationQueueList': 'Nu ai permisiunea de a vedea coada notificărilor.',
  'error.forbiddenUserManagement': 'Nu ai permisiunea de a gestiona utilizatorii.',
  'error.appointmentActionFailed': 'Nu s-a putut actualiza starea programării.',
  'error.appointmentClientTimeOverlap':
    'Acest client are deja o programare care se suprapune cu acest interval. Alege alt interval sau actualizează programarea existentă.',
  'error.appointmentChangeRequestDuplicatePending':
    'Există deja o cerere identică de schimbare în așteptare pentru această programare.',
  'error.downtimeActionFailed': 'Nu s-a putut actualiza înregistrarea de ne-funcționare.',
  'error.downtimeStartSlotGrid': 'Ora de început a ne-funcționării trebuie să respecte grila de 15 minute.',
  'error.downtimeEndSlotGrid': 'Ora estimată de remediere trebuie să respecte grila de 15 minute.',
  'error.downtimeEndAfterStart': 'Ora estimată de remediere trebuie să fie după ora de început.',
  'error.downtimeInvalidTimeRange': 'Intervalul de ne-funcționare este invalid.',
  'error.rescheduleProposalActionFailed': 'Nu s-a putut procesa propunerea de reprogramare.',
  'error.userCreateFailed': 'Nu s-a putut crea utilizatorul.',
  'error.userListLoadFailed': 'Nu s-au putut încărca utilizatorii.',

  'common.loading': 'Se încarcă...',
  'common.noData': 'Fără date',
  'common.yes': 'Da',
  'common.no': 'Nu',
  'common.close': 'Închide',
  'common.cancel': 'Anulează',
  'common.save': 'Salvează',
  'common.saving': 'Se salvează...',
  'common.creating': 'Se creează...',
  'users.createClient': 'Creează client',
  'users.editUser': 'Editează utilizator',
  'users.clientQuickView': 'Vizualizare rapidă client',
  'users.userProfile': 'Profil utilizator',
  'users.error.clientCreateFailed': 'Nu s-a putut crea clientul.',
  'users.error.clientContactRequired': 'Adaugă email sau telefon înainte de a crea clientul.',
  'users.error.clientEmailConflict': 'Există deja un client cu acest email.',
  'users.error.clientResolveFailed': 'Nu s-a putut rezolva înregistrarea clientului.',
  'users.error.fullNameRequired': 'Numele complet este obligatoriu.',
  'security.page.title': 'Securitate',
  'security.page.subtitle': 'Setări pentru autentificarea cu doi factori',
  'security.2fa.title': 'Autentificare cu doi factori (TOTP)',
  'security.loading': 'Se încarcă starea de securitate...',
  'security.required': 'Obligatoriu',
  'security.enabled': 'Activat',
  'security.preparing': 'Se pregătește...',
  'security.setup': 'Configurează 2FA',
  'security.scanAndConfirm': 'Scanează codul QR și confirmă',
  'security.secret': 'Secret',
  'security.qrAlt': 'Cod QR 2FA',
  'security.otpUri': 'URI OTP',
  'security.code': 'Cod 2FA',
  'security.verifying': 'Se verifică...',
  'security.enable': 'Activează 2FA',
  'security.recoveryCodes': 'Coduri de recuperare',
  'security.recoveryHint': 'Păstrează codurile în siguranță. Fiecare cod poate fi folosit o singură dată.',
  'security.disableCode': 'Introdu codul 2FA pentru dezactivare',
  'security.disabling': 'Se dezactivează...',
  'security.disable': 'Dezactivează 2FA',
  'security.mandatoryNoDisable': '2FA este obligatoriu pentru rolul tău și nu poate fi dezactivat.',
  'security.error.setupInit': 'Inițializarea configurării 2FA a eșuat.',
  'security.error.invalidCode': 'Cod 2FA invalid.',
  'security.error.disable': 'Nu s-a putut dezactiva 2FA.',
  'security.error.loadStatus': 'Nu s-a putut încărca starea 2FA.',
  'security.success.enabled': '2FA a fost activat.',
  'security.success.disabled': '2FA a fost dezactivat.',
  'security.policy.title': 'Politică 2FA',
  'security.policy.description': 'Selectează rolurile care trebuie să folosească mereu 2FA.',
  'security.policy.title.system': 'Politica implicită 2FA la nivel de sistem',
  'security.policy.title.company': 'Politica 2FA a companiei',
  'security.policy.description.system': 'Aceste valori implicite sunt moștenite de companii dacă nu există override.',
  'security.policy.description.company': 'Suprascrie rolurile obligatorii 2FA pentru compania ta.',
  'security.policy.source': 'Sursă',
  'security.policy.source.override': 'Override companie',
  'security.policy.source.inherited': 'Moștenit din setările implicite de sistem',
  'security.policy.loading': 'Se încarcă politica...',
  'security.policy.noEditableRoles': 'Nu există roluri editabile în acest context.',
  'security.policy.saving': 'Se salvează...',
  'security.policy.save': 'Salvează politica',
  'security.policy.useSystemDefaults': 'Folosește setările implicite de sistem',
  'security.policy.success.updated': 'Politica a fost actualizată.',
  'security.policy.success.inherited': 'Politica a fost comutată pe valorile moștenite.',
  'security.policy.error.update': 'Nu s-a putut actualiza politica.',
  'security.policy.error.load': 'Nu s-a putut încărca politica 2FA a companiei.',
  'security.policy.error.inherited': 'Nu s-a putut comuta politica pe valorile moștenite.',
  'security.guard.modal.title': 'Configurare 2FA necesară',
  'security.guard.modal.message':
    'Configurarea autentificării cu doi factori este obligatorie. Finalizează configurarea în Securitate înainte de a accesa alte secțiuni.',
  'security.guard.modal.confirm': 'Mergi la Securitate',
  'telegram.page.title': 'Conectori',
  'telegram.page.subtitle': 'Canale externe pentru mesaje, conectare și acțiuni operaționale',
  'telegram.settings.title': 'Bot Telegram tenant',
  'telegram.settings.description': 'Configurează tokenul botului companiei și webhook-ul folosit de notificările Telegram.',
  'telegram.settings.bot': 'Bot',
  'telegram.settings.token': 'Token',
  'telegram.settings.tokenConfigured': 'Configurat',
  'telegram.settings.tokenMissing': 'Lipsește',
  'telegram.settings.webhook': 'Webhook',
  'telegram.settings.webhookConfigured': 'Configurat',
  'telegram.settings.webhookMissing': 'Lipsește',
  'telegram.settings.lastValidated': 'Ultima validare',
  'telegram.settings.botToken': 'Token bot',
  'telegram.settings.keepExistingToken': 'Lasă gol pentru a păstra tokenul existent',
  'telegram.settings.active': 'Telegram activ',
  'telegram.settings.save': 'Salvează setările Telegram',
  'telegram.settings.validate': 'Validează botul',
  'telegram.settings.publicBaseUrlOverride': 'Override URL public de bază',
  'telegram.settings.configureWebhook': 'Configurează webhook',
  'telegram.settings.webhookSecretNote': 'URL-ul webhook conține o cale secretă. Nu îl distribui în afara contextului admin.',
  'telegram.status.active': 'Activ',
  'telegram.status.inactive': 'Inactiv',
  'telegram.saving': 'Se salvează...',
  'telegram.validating': 'Se validează...',
  'telegram.configuringWebhook': 'Se configurează...',
  'telegram.link.title': 'Legătura mea Telegram',
  'telegram.link.description': 'Conectează contul tău de staff la Telegram înainte de activarea notificărilor staff.',
  'telegram.link.clientTitle': 'Telegramul meu',
  'telegram.link.clientDescription': 'Conectează Telegram pentru a primi mesaje despre programări de la clinică.',
  'telegram.link.connected': 'Conectat',
  'telegram.link.notConnected': 'Neconectat',
  'telegram.link.account': 'Cont Telegram',
  'telegram.link.linkedAt': 'Conectat la',
  'telegram.link.deepLink': 'Link de conectare',
  'telegram.link.expiresAt': 'Expiră la',
  'telegram.link.connect': 'Conectează Telegram',
  'telegram.link.preparing': 'Se pregătește...',
  'telegram.link.copy': 'Copiază link',
  'telegram.link.copying': 'Se copiază...',
  'telegram.link.revoke': 'Revocă legătura',
  'telegram.link.revoking': 'Se revocă...',
  'telegram.error.webhookNotConfigured':
    'Webhook-ul Telegram nu este configurat încă. Cere unui administrator să configureze mai întâi webhook-ul tenantului.',
  'common.actions': 'Acțiuni',
  'common.status': 'Stare',
  'common.id': 'ID',
  'Clinic ID': 'ID clinică',
  'Device ID': 'ID echipament',
  'Client ID': 'ID client',
  'Procedure Type': 'Tip procedură',
  'First Slot ID': 'ID primul slot',
  'Specialist User ID (optional)': 'ID specialist (opțional)',
  'Select procedure': 'Selectează procedura',
  'Confirmation required': 'Necesită confirmare',
  'Computed slot count:': 'Număr sloturi calculate:',
  'Computed slots:': 'Sloturi calculate:',
  'Device (optional override)': 'Dispozitiv (suprascriere opțională)',
  'Unable to build contiguous slot block.': 'Nu se poate construi un bloc continuu de sloturi.',
  'Create appointment': 'Creează programare',
  'Edit appointment': 'Editează programarea',
  'Update appointment': 'Actualizează programarea',
  'Updating...': 'Se actualizează...',
  'Update pending request before confirmation': 'Actualizează cererea înainte de confirmare',
  'Lock client time changes (client can only accept or cancel)':
    'Blochează schimbarea orei de către client (clientul poate doar accepta sau anula)',
  'Create downtime': 'Creează ne-funcționare',
  'Back to edit': 'Înapoi la editare',
  All: 'Toate',
  'Date From': 'Data de la',
  'Date To': 'Data până la',
  'Next 14 days': 'Următoarele 14 zile',
  'Next 30 days': 'Următoarele 30 de zile',
  'This week': 'Săptămâna aceasta',
  'This month': 'Luna aceasta',
  'Apply Filters': 'Aplică filtre',
  Reset: 'Resetează',
  'Work Date': 'Data de lucru',
  'Day Start': 'Început zi',
  'Day End': 'Sfârșit zi',
  'Generating...': 'Se generează...',
  'Event Type': 'Tip eveniment',
  'Entity Type': 'Tip entitate',
  'Entity ID': 'ID entitate',
  'Recipient Email': 'Email destinatar',
  'Updated At': 'Actualizat la',
  'Request Note': 'Notă solicitare',
  'Review Note': 'Notă revizuire',
  'Optional note': 'Notă opțională',
  'Change request history': 'Istoric cereri de modificare',
  'clientReliability.title': 'Fiabilitatea clientului',
  'clientReliability.titleShort': 'Fiabilitate',
  'clientReliability.historyTitle': 'Istoric fiabilitate',
  'clientReliability.manualAdjustmentTitle': 'Ajustare manuală',
  'clientReliability.manualDelta': 'Ajustare (%)',
  'clientReliability.manualReason': 'Motiv / Comentariu',
  'clientReliability.manualReasonRequired': 'Motivul este obligatoriu conform politicii companiei',
  'clientReliability.manualSubmit': 'Aplică ajustarea',
  'clientReliability.label.reliable': 'Fiabil',
  'clientReliability.label.watch': 'Monitorizare',
  'clientReliability.label.risk': 'Risc',
  'clientReliability.event.lateCancel': 'Anulare târzie',
  'clientReliability.event.noShow': 'Neprezentare',
  'clientReliability.event.lateArrival': 'Întârziere la sosire',
  'clientReliability.event.clientReschedule': 'Reprogramare inițiată de client',
  'clientReliability.event.attendedOnTime': 'Prezentare la timp',
  'clientReliability.event.manualAdjustment': 'Ajustare manuală',
  'clientReliability.manualAdjustmentSuccess': 'Scorul de fiabilitate a fost actualizat.',
  'clientReliability.manualAdjustmentError': 'Nu s-a putut ajusta fiabilitatea clientului',
  'clientReliability.churnStep': 'Pasul reprogramării',
  Operations: 'Operațiuni',
  Mail: 'Mail',
  Branding: 'Branding',
  Global: 'Global',
  'settings.rating.tab': 'Rating',
  'settings.rating.title': 'Setări rating',
  'settings.rating.description':
    'Aceste ponderi definesc scorul CRM intern de fiabilitate pentru clienți. Ele nu afectează feedbackul vizibil pentru client.',
  'settings.rating.lateCancelPenalty': 'Penalizare anulare târzie (%)',
  'settings.rating.lateCancelWindowHours': 'Fereastră anulare târzie (ore)',
  'settings.rating.noShowPenalty': 'Penalizare no-show (%)',
  'settings.rating.lateArrivalPenalty': 'Penalizare întârziere client (%)',
  'settings.rating.firstClientReschedulePenalty': 'Penalizare prima reprogramare client (%)',
  'settings.rating.secondClientReschedulePenalty': 'Penalizare a doua reprogramare client (%)',
  'settings.rating.thirdPlusClientReschedulePenalty': 'Penalizare a treia+ reprogramare client (%)',
  'settings.rating.attendedOnTimeBonus': 'Bonus prezentare la timp (%)',
  'settings.rating.watchThreshold': 'Prag monitorizare (%)',
  'settings.rating.riskThreshold': 'Prag risc (%)',
  'settings.rating.manualAdjustmentAllowed': 'Permite ajustare manuală',
  'settings.rating.manualAdjustmentReasonRequired': 'Solicită motiv pentru ajustarea manuală',
  'settings.rating.save': 'Salvează setările ratingului',
  'settings.rating.success.saved': 'Setările ratingului au fost salvate',
  'settings.rating.error.thresholdOrder': 'Pragul de risc nu poate fi mai mare decât pragul de monitorizare.',
  'settings.rating.context.company': 'Editezi politica internă de fiabilitate a clienților pentru compania ta.',
  'settings.rating.context.systemSelectedCompany':
    'Editezi politica internă de fiabilitate a clienților pentru compania selectată.',
  'settings.rating.context.systemSelectCompany':
    'Selectează o companie pentru a edita politica internă de fiabilitate a clienților.',
  'Reviewed At': 'Revizuit la',
  'Requested vs Current': 'Solicitat vs curent',
  Proposal: 'Propunere',
  'Old Primary Slot': 'Slot principal vechi',
  'New Primary Slot': 'Slot principal nou',
  'Select a proposal to view details': 'Selectează o propunere pentru detalii',
  'Expected Repair Until': 'Reparare estimată până la',
  'Actual End Time': 'Timp final real',
  'Affected Appointments': 'Programări afectate',
  Edit: 'Editează',
  Delete: 'Șterge',
  Status: 'Status',
  Actions: 'Acțiuni',
  Enabled: 'Activă',
  Disabled: 'Dezactivată',
  Enable: 'Activează',
  Disable: 'Dezactivează',

  'status.pending': 'În așteptare',
  'status.pendingApproval': 'În așteptarea aprobării',
  'status.pendingConfirmation': 'În așteptare',
  'status.confirmed': 'Confirmat',
  'status.completed': 'Finalizat',
  'status.cancelled': 'Anulat',
  'status.noShow': 'Neprezentare',
  'status.rescheduleRequired': 'Necesită reprogramare',
  'appointments.tabs.schedule': 'Program',
  'appointments.tabs.reschedule': 'Reprogramare',
  'appointments.tabs.clientMap': 'Hartă client',
  'appointments.tabs.fluidCapacity': 'Capacitate fluidă',
  'appointments.tabs.capacityStage': 'Capacity Stage',
  'appointments.tabs.capacityMatrix': 'Capacity Matrix',
  'appointments.tabs.changeRequests': 'Cereri de schimbare',
  'appointments.filters.allStatuses': 'Toate stările',
  'appointments.filters.sort': 'Sortare',
  'appointments.sort.createdAtDesc': 'Cele mai noi create',
  'appointments.sort.createdAtAsc': 'Cele mai vechi create',
  'appointments.sort.startAtAsc': 'Cele mai apropiate programări',
  'appointments.sort.startAtDesc': 'Cele mai târzii programări',
  'notificationQueue.sort.createdAtDesc': 'Cele mai noi create',
  'notificationQueue.sort.createdAtAsc': 'Cele mai vechi create',
  'notificationQueue.sort.updatedAtDesc': 'Actualizate recent',
  'notificationQueue.sort.updatedAtAsc': 'Cele mai vechi actualizate',
  'slots.sort.startAtAsc': 'Cele mai timpurii sloturi',
  'slots.sort.startAtDesc': 'Cele mai târzii sloturi',
  'slots.sort.createdAtDesc': 'Cele mai noi create',
  'slots.sort.createdAtAsc': 'Cele mai vechi create',
  'status.accepted': 'Acceptat',
  'status.approved': 'Aprobat',
  'status.rejected': 'Respins',
  'status.expired': 'Expirat',
  'status.revoked': 'Revocat',
  'status.available': 'Disponibil',
  'status.past': 'Trecut',
  'status.reserved': 'Rezervat',
  'status.blocked': 'Blocat',
  'status.processing': 'În procesare',
  'status.sent': 'Trimis',
  'status.failed': 'Eșuat',
  'status.scheduled': 'Planificat',
  'status.active': 'Activ',
  'status.resolved': 'Rezolvat',

  'action.confirm': 'Confirmă',
  'action.checkIn': 'Check-in',
  'action.finish': 'Finalizează vizita',
  'action.noShow': 'Marchează neprezentare',
  'action.edit': 'Editează',
  'action.complete': 'Finalizează',
  'action.cancel': 'Anulează',
  'action.approve': 'Aprobă',
  'action.accept': 'Acceptă',
  'action.reject': 'Respinge',
  'action.createAppointment': 'Creează programare',
  'Auto (from slot)': 'Auto (din slot)',
  'Select first slot': 'Selectează primul slot',
  'Manual device override': 'Suprascriere manuală dispozitiv',
  Table: 'Tabel',
  Calendar: 'Calendar',
  'slots.previousDay': 'Ziua anterioară',
  'slots.today': 'Astăzi',
  'slots.nextDay': 'Ziua următoare',
  'slots.selectedDay': 'Zi selectată',
  'slots.allDevices': 'Toate dispozitivele',
  'slots.allSpecialists': 'Toți specialiștii',
  'slots.staffSummary.available': 'Disponibile',
  'slots.staffSummary.reserved': 'Rezervate',
  'slots.staffSummary.blocked': 'Blocate',
  'slots.staffSummary.completed': 'Finalizate',
  'slots.staffSummary.specialists': 'Specialiști',
  'slots.staffSummary.devices': 'Dispozitive',
  'slots.staffSummary.capacityWindows': 'Ferestre capacitate',
  'slots.staffSummary.hardUnavailable': 'Indisponibile',
  'slots.staffSummary.specialistCapacity': 'Capacitate specialiști',
  'slots.staffSummary.deviceCapacity': 'Capacitate dispozitive',

  Appointments: 'Programări',
  Slots: 'Intervale',
  Downtime: 'Ne-funcționare',
  'Reschedule Proposals': 'Propuneri de reprogramare',
  'Notification Queue': 'Coada notificărilor',
  'Device Downtime': 'Ne-funcționare echipament',
  'Create Appointment': 'Creează programare',
  'Create Device Downtime': 'Creează ne-funcționare echipament',
  'User Management': 'Administrare utilizatori',

  'Operational view of current appointments': 'Vedere operațională a programărilor curente',
  'Operational view of slot inventory': 'Vedere operațională a intervalelor',
  'Appointments affected by downtime': 'Programări afectate de ne-funcționare',
  'Outbox and delivery status overview': 'Prezentare outbox și stare livrare',
  'Manual operational creation form': 'Formular manual operațional de creare',
  'Manual maintenance and outage registration': 'Înregistrare manuală de mentenanță și avarie',
  'Create test users for role and guard validation': 'Creează utilizatori de test pentru validarea rolurilor și a guard-urilor',

  'Loading appointments...': 'Se încarcă programările...',
  'Loading slots...': 'Se încarcă intervalele...',
  'Loading proposals...': 'Se încarcă propunerile...',
  'Loading notification queue...': 'Se încarcă coada notificărilor...',
  'Loading downtime items...': 'Se încarcă înregistrările de ne-funcționare...',
  'Loading device downtime...': 'Se încarcă ne-funcționarea echipamentelor...',
  'Loading users...': 'Se încarcă utilizatorii...',
  'Loading profile...': 'Se încarcă profilul...',

  'Failed to load appointments': 'Nu s-au putut încărca programările',
  'Failed to load slots': 'Nu s-au putut încărca intervalele',
  'Failed to load proposals': 'Nu s-au putut încărca propunerile',
  'Failed to load notification queue': 'Nu s-a putut încărca coada notificărilor',
  'Failed to load downtime items': 'Nu s-au putut încărca înregistrările de ne-funcționare',
  'Failed to load device downtime': 'Nu s-a putut încărca ne-funcționarea echipamentelor',
  'Failed to load users': 'Nu s-au putut încărca utilizatorii',
  'Failed to load profile': 'Nu s-a putut încărca profilul',

  'No appointments found': 'Nu s-au găsit programări',
  'No slots found': 'Nu s-au găsit intervale',
  'No proposals found': 'Nu s-au găsit propuneri',
  'No notification jobs found': 'Nu s-au găsit notificări',
  'No downtime records found': 'Nu s-au găsit înregistrări de ne-funcționare',
  'No users found': 'Nu s-au găsit utilizatori',
  'Profile not found': 'Profilul nu a fost găsit',

  'The appointments list is currently empty.': 'Lista programărilor este goală momentan.',
  'No slots matched the current filters.': 'Niciun interval nu corespunde filtrelor curente.',
  'No proposals matched the current filters.': 'Nicio propunere nu corespunde filtrelor curente.',
  'No notification queue jobs for current filters.': 'Nu există notificări pentru filtrele curente.',
  'No downtime records for current filters.': 'Nu există înregistrări de ne-funcționare pentru filtrele curente.',
  'The slot list is currently empty for the selected filter set.': 'Lista sloturilor este goală pentru filtrele selectate.',
  'The notification queue is currently empty.': 'Coada notificărilor este momentan goală.',
  'The downtime list is currently empty.': 'Lista de ne-funcționare este momentan goală.',
  'Currently there are no reschedule proposals.': 'Momentan nu există propuneri de reprogramare.',
  'Operational view of maintenance and outage windows': 'Vedere operațională a ferestrelor de mentenanță și avarie',
  'No users available for this company yet.': 'Nu există încă utilizatori pentru această companie.',
  Retry: 'Reîncearcă',
  'Load more': 'Încarcă mai multe',
  'Loading more...': 'Se încarcă mai multe...',
  'downtime.pendingApprovals': 'Aprobări în așteptare',
  'No client profile is linked to your account yet.': 'Niciun profil client nu este asociat contului tău.',
  'My Profile': 'Profilul meu',
  'Personal account information': 'Informații personale ale contului',
  'Full Name': 'Nume complet',
  Phone: 'Telefon',
  'Birth Date': 'Data nașterii',
  Notes: 'Note',

  Clinic: 'Clinică',
  Client: 'Client',
  Procedure: 'Procedură',
  Device: 'Echipament',
  Specialist: 'Specialist',
  'Primary Slot': 'Interval principal',
  'Confirmation Required': 'Confirmare necesară',
  'Confirmed At': 'Confirmat la',
  Source: 'Sursă',
  Appointment: 'Programare',
  'Old Slot': 'Interval vechi',
  'New Slot': 'Interval nou',
  Reason: 'Motiv',
  Created: 'Creat',
  'Start Time': 'Ora început',
  'End Time': 'Ora sfârșit',
  Role: 'Rol',
  Active: 'Activ',
  Inactive: 'Inactiv',
  'Create user': 'Creează utilizator',
  'role.manager': 'Manager',
  'role.technician': 'Tehnician',
  'role.specialist': 'Specialist',
  'role.reception': 'Recepție',
  'role.client': 'Client',
  'role.company_admin': 'Administrator companie',
  'role.system_admin': 'Administrator sistem'
};

const ru: Record<string, string> = {
  'app.brand': 'Клиника Платформа',
  'app.shellTitle': 'Операционная Панель',
  'app.logout': 'Выйти',
  'app.language': 'Язык',

  'nav.appointments': 'Записи',
  'nav.slots': 'Слоты',
  'nav.devices': 'Устройства',
  'nav.downtime': 'Простой',
  'nav.specialistDowntime': 'Простой специалиста',
  'nav.rescheduleProposals': 'Предложения переноса',
  'nav.appointmentChangeRequests': 'Запросы на изменение',
  'nav.notificationQueue': 'Очередь уведомлений',
  'nav.notificationTemplates': 'Шаблоны уведомлений',
  'nav.notification': 'Уведомления',
  'nav.users': 'Управление пользователями',
  'nav.procedureTypes': 'Типы процедур',
  'nav.companies': 'Компании',
  'nav.myProfile': 'Мой профиль',
  'nav.settings': 'Настройки',
  'nav.clinics': 'Клиники',
  'nav.globalSettings': 'Глобальные настройки',
  'nav.dataRetention': 'Хранение данных',
  'nav.security': 'Безопасность',
  'nav.connectors': 'Коннекторы',

  'auth.signInSubtitle': 'Войдите, чтобы открыть операционную панель',
  'auth.email': 'Email',
  'auth.password': 'Пароль',
  'auth.enterEmail': 'Введите email',
  'auth.enterPassword': 'Введите пароль',
  'auth.signIn': 'Войти',
  'auth.signingIn': 'Вход...',
  'auth.loginFailed': 'Ошибка входа. Проверьте логин и пароль.',
  'auth.loginTenantUrlRequired': 'Открой URL входа компании, чтобы продолжить авторизацию.',
  'auth.2faCode': 'Код 2FA',
  'auth.2faCodePlaceholder': 'Введите 6-значный код',
  'auth.trustDevice': 'Доверять этому устройству (пропускать 2FA в следующий раз)',
  'auth.createClientAccount': 'Создать аккаунт клиента',
  'auth.registerTitle': 'Регистрация клиента',
  'auth.registerSubtitle': 'Создайте аккаунт в компании',
  'auth.register': 'Зарегистрироваться',
  'auth.registering': 'Регистрация...',
  'auth.confirmPassword': 'Подтвердите пароль',
  'auth.backToLogin': 'Назад ко входу',
  'auth.passwordMismatch': 'Пароли не совпадают.',
  'auth.registrationFailed': 'Не удалось зарегистрироваться. Попробуйте снова.',
  'auth.registrationEmailExists': 'Клиент с таким email уже существует в этой компании.',
  'auth.registrationSuccess': 'Регистрация успешна. Проверьте email для активации аккаунта.',
  'auth.loginEmailVerificationRequired': 'Email ещё не подтверждён. Проверьте почту и подтвердите аккаунт.',
  'auth.verifyEmailTitle': 'Подтверждение Email',
  'auth.verifyEmailLoading': 'Подтверждаем email...',
  'auth.verifyEmailSuccess': 'Email подтверждён. Теперь можно войти.',
  'auth.verifyEmailInvalid': 'Ссылка подтверждения недействительна.',
  'auth.verifyEmailFailed': 'Подтверждение не удалось или ссылка истекла.',
  'auth.registrationUnavailable': 'Регистрация доступна только в контексте URL компании.',
  'auth.inviteAcceptTitle': 'Завершение активации приглашённого аккаунта',
  'auth.inviteAcceptSubtitle': 'Задай пароль, чтобы активировать приглашённый аккаунт клиента.',
  'auth.staffInviteAcceptSubtitle': 'Задай пароль, чтобы активировать приглашённый аккаунт сотрудника.',
  'auth.inviteAcceptLoading': 'Загружаем данные приглашения...',
  'auth.inviteAcceptSubmit': 'Активировать аккаунт',
  'auth.inviteAcceptSubmitting': 'Активируем аккаунт...',
  'auth.inviteAcceptSuccess': 'Аккаунт активирован. Теперь можно войти.',
  'auth.inviteAcceptFailed': 'Не удалось активировать приглашение. Попробуй снова.',
  'auth.inviteMetaFailed': 'Не удалось загрузить данные приглашения.',
  'auth.inviteInvalid': 'Ссылка приглашения недействительна.',
  'auth.inviteExpired': 'Срок действия ссылки приглашения истёк.',
  'auth.inviteConflict': 'Email из этого приглашения уже используется другим аккаунтом.',
  'auth.inviteExpiresAt': 'Приглашение действует до',
  Company: 'Компания',
  'Select company': 'Выберите компанию',
  'Loading companies...': 'Загрузка компаний...',
  'System admin login uses automatic company context.': 'Для system admin контекст компании определяется автоматически.',
  'error.generic': 'Запрос не выполнен. Попробуйте снова.',
  'error.network': 'Ошибка сети. Проверьте соединение и попробуйте снова.',
  'error.forbiddenResource': 'У вас нет прав на просмотр этих данных.',
  'error.settingsCompanyContextRequired': 'Выберите компанию в верхней панели, чтобы просматривать настройки.',
  'error.forbiddenAppointmentCreate': 'У вас нет прав на создание записей.',
  'error.forbiddenAppointmentAction': 'У вас нет прав на изменение записей.',
  'error.forbiddenAppointmentsList': 'У вас нет прав на просмотр записей.',
  'error.forbiddenDowntimeCreate': 'У вас нет прав на создание запросов простоя.',
  'error.forbiddenDowntimeAction': 'У вас нет прав на управление записями простоев.',
  'error.forbiddenDowntimeList': 'У вас нет прав на просмотр записей простоев.',
  'error.forbiddenRescheduleProposalAction': 'У вас нет прав на обработку предложений переноса.',
  'error.forbiddenRescheduleProposalsList': 'У вас нет прав на просмотр предложений переноса.',
  'error.forbiddenSlotsList': 'У вас нет прав на просмотр слотов.',
  'error.forbiddenNotificationQueueList': 'У вас нет прав на просмотр очереди уведомлений.',
  'error.forbiddenUserManagement': 'У вас нет прав на управление пользователями.',
  'error.appointmentActionFailed': 'Не удалось обновить статус записи.',
  'error.appointmentClientTimeOverlap':
    'У этого клиента уже есть запись, которая пересекается с выбранным временем. Выберите другое время или измените существующую запись.',
  'error.appointmentChangeRequestDuplicatePending':
    'Для этой записи уже существует идентичный ожидающий запрос на изменение.',
  'error.downtimeActionFailed': 'Не удалось обновить запись простоя.',
  'error.downtimeStartSlotGrid': 'Начало простоя должно попадать в 15-минутную сетку слотов.',
  'error.downtimeEndSlotGrid': 'Ожидаемое время восстановления должно попадать в 15-минутную сетку слотов.',
  'error.downtimeEndAfterStart': 'Ожидаемое время восстановления должно быть позже начала простоя.',
  'error.downtimeInvalidTimeRange': 'Некорректный интервал простоя.',
  'error.rescheduleProposalActionFailed': 'Не удалось обработать предложение переноса.',
  'error.userCreateFailed': 'Не удалось создать пользователя.',
  'error.userListLoadFailed': 'Не удалось загрузить пользователей.',

  'common.loading': 'Загрузка...',
  'common.noData': 'Нет данных',
  'common.yes': 'Да',
  'common.no': 'Нет',
  'common.close': 'Закрыть',
  'common.cancel': 'Отмена',
  'common.save': 'Сохранить',
  'common.saving': 'Сохранение...',
  'common.creating': 'Создание...',
  'users.createClient': 'Создать клиента',
  'users.editUser': 'Изменить пользователя',
  'users.clientQuickView': 'Быстрый просмотр клиента',
  'users.userProfile': 'Профиль пользователя',
  'users.error.clientCreateFailed': 'Не удалось создать клиента.',
  'users.error.clientContactRequired': 'Добавьте email или телефон перед созданием клиента.',
  'users.error.clientEmailConflict': 'Клиент с таким email уже существует.',
  'users.error.clientResolveFailed': 'Не удалось определить запись клиента.',
  'users.error.fullNameRequired': 'Укажите полное имя.',
  'security.page.title': 'Безопасность',
  'security.page.subtitle': 'Настройки двухфакторной аутентификации',
  'security.2fa.title': 'Двухфакторная аутентификация (TOTP)',
  'security.loading': 'Загрузка статуса безопасности...',
  'security.required': 'Обязательно',
  'security.enabled': 'Включено',
  'security.preparing': 'Подготовка...',
  'security.setup': 'Настроить 2FA',
  'security.scanAndConfirm': 'Отсканируйте QR и подтвердите',
  'security.secret': 'Секрет',
  'security.qrAlt': 'QR-код 2FA',
  'security.otpUri': 'OTP URI',
  'security.code': 'Код 2FA',
  'security.verifying': 'Проверка...',
  'security.enable': 'Включить 2FA',
  'security.recoveryCodes': 'Коды восстановления',
  'security.recoveryHint': 'Сохраните эти коды в безопасном месте. Каждый код можно использовать только один раз.',
  'security.disableCode': 'Введите код 2FA для отключения',
  'security.disabling': 'Отключение...',
  'security.disable': 'Отключить 2FA',
  'security.mandatoryNoDisable': '2FA обязательно для вашей роли и не может быть отключено.',
  'security.error.setupInit': 'Не удалось инициализировать настройку 2FA.',
  'security.error.invalidCode': 'Неверный код 2FA.',
  'security.error.disable': 'Не удалось отключить 2FA.',
  'security.error.loadStatus': 'Не удалось загрузить статус 2FA.',
  'security.success.enabled': '2FA включена.',
  'security.success.disabled': '2FA отключена.',
  'security.policy.title': 'Политика 2FA',
  'security.policy.description': 'Выберите роли, для которых 2FA всегда обязательно.',
  'security.policy.title.system': 'Системная политика 2FA по умолчанию',
  'security.policy.title.company': 'Политика 2FA компании',
  'security.policy.description.system': 'Эти значения по умолчанию наследуются компаниями, если не задан override.',
  'security.policy.description.company': 'Переопределите обязательные роли 2FA для вашей компании.',
  'security.policy.source': 'Источник',
  'security.policy.source.override': 'Переопределение компании',
  'security.policy.source.inherited': 'Унаследовано из системных настроек по умолчанию',
  'security.policy.loading': 'Загрузка политики...',
  'security.policy.noEditableRoles': 'В этом контексте нет редактируемых ролей.',
  'security.policy.saving': 'Сохранение...',
  'security.policy.save': 'Сохранить политику',
  'security.policy.useSystemDefaults': 'Использовать системные значения по умолчанию',
  'security.policy.success.updated': 'Политика обновлена.',
  'security.policy.success.inherited': 'Политика переключена на унаследованные значения.',
  'security.policy.error.update': 'Не удалось обновить политику.',
  'security.policy.error.load': 'Не удалось загрузить политику 2FA компании.',
  'security.policy.error.inherited': 'Не удалось переключить политику на унаследованные значения.',
  'security.guard.modal.title': 'Требуется настройка 2FA',
  'security.guard.modal.message':
    'Требуется настроить двухфакторную аутентификацию. Завершите настройку в разделе «Безопасность» перед доступом к другим разделам.',
  'security.guard.modal.confirm': 'Перейти в Безопасность',
  'telegram.page.title': 'Коннекторы',
  'telegram.page.subtitle': 'Внешние каналы для сообщений, привязки и операционных действий',
  'telegram.settings.title': 'Telegram-бот компании',
  'telegram.settings.description': 'Настройте токен бота компании и webhook для Telegram-уведомлений.',
  'telegram.settings.bot': 'Бот',
  'telegram.settings.token': 'Токен',
  'telegram.settings.tokenConfigured': 'Настроен',
  'telegram.settings.tokenMissing': 'Нет',
  'telegram.settings.webhook': 'Webhook',
  'telegram.settings.webhookConfigured': 'Настроен',
  'telegram.settings.webhookMissing': 'Нет',
  'telegram.settings.lastValidated': 'Последняя проверка',
  'telegram.settings.botToken': 'Токен бота',
  'telegram.settings.keepExistingToken': 'Оставьте пустым, чтобы сохранить текущий токен',
  'telegram.settings.active': 'Telegram активен',
  'telegram.settings.save': 'Сохранить настройки Telegram',
  'telegram.settings.validate': 'Проверить бота',
  'telegram.settings.publicBaseUrlOverride': 'Override публичного base URL',
  'telegram.settings.configureWebhook': 'Настроить webhook',
  'telegram.settings.webhookSecretNote': 'Webhook URL содержит секретный путь. Не показывайте его вне admin-контекста.',
  'telegram.status.active': 'Активен',
  'telegram.status.inactive': 'Неактивен',
  'telegram.saving': 'Сохранение...',
  'telegram.validating': 'Проверка...',
  'telegram.configuringWebhook': 'Настройка...',
  'telegram.link.title': 'Моя привязка Telegram',
  'telegram.link.description': 'Привяжите свой staff-аккаунт к Telegram перед включением уведомлений сотрудникам.',
  'telegram.link.clientTitle': 'Мой Telegram',
  'telegram.link.clientDescription': 'Подключите Telegram, чтобы получать сообщения о записях от клиники.',
  'telegram.link.connected': 'Привязан',
  'telegram.link.notConnected': 'Не привязан',
  'telegram.link.account': 'Аккаунт Telegram',
  'telegram.link.linkedAt': 'Привязан в',
  'telegram.link.deepLink': 'Ссылка привязки',
  'telegram.link.expiresAt': 'Истекает',
  'telegram.link.connect': 'Подключить Telegram',
  'telegram.link.preparing': 'Подготовка...',
  'telegram.link.copy': 'Скопировать ссылку',
  'telegram.link.copying': 'Копирование...',
  'telegram.link.revoke': 'Отозвать привязку',
  'telegram.link.revoking': 'Отзыв...',
  'telegram.error.webhookNotConfigured':
    'Telegram webhook ещё не настроен. Попросите администратора сначала настроить webhook tenant.',
  'common.actions': 'Действия',
  'common.status': 'Статус',
  'common.id': 'ID',
  'Clinic ID': 'ID клиники',
  'Device ID': 'ID устройства',
  'Client ID': 'ID клиента',
  'Procedure Type': 'Тип процедуры',
  'First Slot ID': 'ID первого слота',
  'Specialist User ID (optional)': 'ID специалиста (опционально)',
  'Select procedure': 'Выберите процедуру',
  'Confirmation required': 'Требуется подтверждение',
  'Computed slot count:': 'Рассчитано слотов:',
  'Computed slots:': 'Рассчитанные слоты:',
  'Device (optional override)': 'Устройство (необязательное переопределение)',
  'Unable to build contiguous slot block.': 'Не удалось собрать непрерывный блок слотов.',
  'Create appointment': 'Создать запись',
  'Edit appointment': 'Изменить запись',
  'Update appointment': 'Обновить запись',
  'Updating...': 'Обновление...',
  'Update pending request before confirmation': 'Обновите заявку перед подтверждением',
  'Lock client time changes (client can only accept or cancel)':
    'Запретить клиенту менять время (клиент может только принять или отменить)',
  'Create downtime': 'Создать простой',
  'Back to edit': 'Вернуться к редактированию',
  All: 'Все',
  'Date From': 'Дата с',
  'Date To': 'Дата по',
  'Next 14 days': 'Следующие 14 дней',
  'Next 30 days': 'Следующие 30 дней',
  'This week': 'Эта неделя',
  'This month': 'Этот месяц',
  'Apply Filters': 'Применить фильтры',
  Reset: 'Сбросить',
  'Work Date': 'Рабочая дата',
  'Day Start': 'Начало дня',
  'Day End': 'Конец дня',
  'Generating...': 'Генерация...',
  'Event Type': 'Тип события',
  'Entity Type': 'Тип сущности',
  'Entity ID': 'ID сущности',
  'Recipient Email': 'Email получателя',
  'Updated At': 'Обновлено в',
  'Request Note': 'Комментарий запроса',
  'Review Note': 'Комментарий решения',
  'Optional note': 'Необязательный комментарий',
  'Change request history': 'История запросов на изменение',
  'clientReliability.title': 'Надежность клиента',
  'clientReliability.titleShort': 'Надежность',
  'clientReliability.historyTitle': 'История надежности',
  'clientReliability.manualAdjustmentTitle': 'Ручная корректировка',
  'clientReliability.manualDelta': 'Корректировка (%)',
  'clientReliability.manualReason': 'Причина / Комментарий',
  'clientReliability.manualReasonRequired': 'Причина обязательна по политике компании',
  'clientReliability.manualSubmit': 'Применить корректировку',
  'clientReliability.label.reliable': 'Надежный',
  'clientReliability.label.watch': 'Под наблюдением',
  'clientReliability.label.risk': 'Риск',
  'clientReliability.event.lateCancel': 'Поздняя отмена',
  'clientReliability.event.noShow': 'Неявка',
  'clientReliability.event.lateArrival': 'Опоздание',
  'clientReliability.event.clientReschedule': 'Перенос по инициативе клиента',
  'clientReliability.event.attendedOnTime': 'Визит вовремя',
  'clientReliability.event.manualAdjustment': 'Ручная корректировка',
  'clientReliability.manualAdjustmentSuccess': 'Оценка надежности обновлена.',
  'clientReliability.manualAdjustmentError': 'Не удалось скорректировать надежность клиента',
  'clientReliability.churnStep': 'Шаг переноса',
  Operations: 'Операции',
  Mail: 'Почта',
  Branding: 'Брендинг',
  Global: 'Глобальные',
  'settings.rating.tab': 'Рейтинг',
  'settings.rating.title': 'Настройки рейтинга',
  'settings.rating.description':
    'Эти веса определяют внутренний CRM-рейтинг надежности клиентов. Они не влияют на клиентский feedback.',
  'settings.rating.lateCancelPenalty': 'Штраф за позднюю отмену (%)',
  'settings.rating.lateCancelWindowHours': 'Окно поздней отмены (часы)',
  'settings.rating.noShowPenalty': 'Штраф за неявку (%)',
  'settings.rating.lateArrivalPenalty': 'Штраф за опоздание клиента (%)',
  'settings.rating.firstClientReschedulePenalty': 'Штраф за первый перенос по инициативе клиента (%)',
  'settings.rating.secondClientReschedulePenalty': 'Штраф за второй перенос по инициативе клиента (%)',
  'settings.rating.thirdPlusClientReschedulePenalty': 'Штраф за третий и последующие переносы (%)',
  'settings.rating.attendedOnTimeBonus': 'Бонус за визит вовремя (%)',
  'settings.rating.watchThreshold': 'Порог наблюдения (%)',
  'settings.rating.riskThreshold': 'Порог риска (%)',
  'settings.rating.manualAdjustmentAllowed': 'Разрешить ручную корректировку',
  'settings.rating.manualAdjustmentReasonRequired': 'Требовать причину для ручной корректировки',
  'settings.rating.save': 'Сохранить настройки рейтинга',
  'settings.rating.success.saved': 'Настройки рейтинга сохранены',
  'settings.rating.error.thresholdOrder': 'Порог риска не может быть выше порога наблюдения.',
  'settings.rating.context.company': 'Вы редактируете внутреннюю политику надежности клиентов для своей компании.',
  'settings.rating.context.systemSelectedCompany':
    'Вы редактируете внутреннюю политику надежности клиентов для выбранной компании.',
  'settings.rating.context.systemSelectCompany':
    'Выберите компанию, чтобы редактировать внутреннюю политику надежности клиентов.',
  'Reviewed At': 'Рассмотрено в',
  'Requested vs Current': 'Запрошено vs текущее',
  Proposal: 'Предложение',
  'Old Primary Slot': 'Старый основной слот',
  'New Primary Slot': 'Новый основной слот',
  'Select a proposal to view details': 'Выберите предложение для просмотра деталей',
  'Expected Repair Until': 'Ожидаемый ремонт до',
  'Actual End Time': 'Фактическое время окончания',
  'Affected Appointments': 'Затронутые записи',
  Edit: 'Изменить',
  Delete: 'Удалить',
  Status: 'Статус',
  Actions: 'Действия',
  Enabled: 'Включена',
  Disabled: 'Выключена',
  Enable: 'Включить',
  Disable: 'Выключить',

  'status.pending': 'Ожидает',
  'status.pendingApproval': 'Ожидает подтверждения',
  'status.pendingConfirmation': 'В ожидании',
  'status.confirmed': 'Подтверждена',
  'status.completed': 'Завершена',
  'status.cancelled': 'Отменена',
  'status.noShow': 'Неявка',
  'status.rescheduleRequired': 'Требуется перенос',
  'appointments.tabs.schedule': 'Расписание',
  'appointments.tabs.reschedule': 'Перенос',
  'appointments.tabs.clientMap': 'Карта клиента',
  'appointments.tabs.fluidCapacity': 'Fluid Capacity',
  'appointments.tabs.capacityStage': 'Capacity Stage',
  'appointments.tabs.capacityMatrix': 'Capacity Matrix',
  'appointments.tabs.changeRequests': 'Запросы на изменение',
  'appointments.filters.allStatuses': 'Все статусы',
  'appointments.filters.sort': 'Сортировка',
  'appointments.sort.createdAtDesc': 'Сначала новые созданные',
  'appointments.sort.createdAtAsc': 'Сначала старые созданные',
  'appointments.sort.startAtAsc': 'Ближайшие записи',
  'appointments.sort.startAtDesc': 'Самые поздние записи',
  'notificationQueue.sort.createdAtDesc': 'Сначала новые созданные',
  'notificationQueue.sort.createdAtAsc': 'Сначала старые созданные',
  'notificationQueue.sort.updatedAtDesc': 'Недавно обновлённые',
  'notificationQueue.sort.updatedAtAsc': 'Давно обновлённые',
  'slots.sort.startAtAsc': 'Сначала ранние слоты',
  'slots.sort.startAtDesc': 'Сначала поздние слоты',
  'slots.sort.createdAtDesc': 'Сначала новые созданные',
  'slots.sort.createdAtAsc': 'Сначала старые созданные',
  'status.accepted': 'Принято',
  'status.approved': 'Одобрено',
  'status.rejected': 'Отклонено',
  'status.expired': 'Истекло',
  'status.revoked': 'Отозвано',
  'status.available': 'Доступен',
  'status.past': 'В прошлом',
  'status.reserved': 'Зарезервирован',
  'status.blocked': 'Заблокирован',
  'status.processing': 'Обрабатывается',
  'status.sent': 'Отправлено',
  'status.failed': 'Ошибка',
  'status.scheduled': 'Запланировано',
  'status.active': 'Активен',
  'status.resolved': 'Решено',

  'action.confirm': 'Подтвердить',
  'action.checkIn': 'Отметить приход',
  'action.finish': 'Завершить визит',
  'action.noShow': 'Отметить неявку',
  'action.edit': 'Изменить',
  'action.complete': 'Завершить',
  'action.cancel': 'Отменить',
  'action.approve': 'Одобрить',
  'action.accept': 'Принять',
  'action.reject': 'Отклонить',
  'action.createAppointment': 'Создать запись',
  'Auto (from slot)': 'Авто (из слота)',
  'Select first slot': 'Выберите первый слот',
  'Manual device override': 'Ручной override устройства',
  Table: 'Таблица',
  Calendar: 'Календарь',
  'slots.previousDay': 'Предыдущий день',
  'slots.today': 'Сегодня',
  'slots.nextDay': 'Следующий день',
  'slots.selectedDay': 'Выбранный день',
  'slots.allDevices': 'Все устройства',
  'slots.allSpecialists': 'Все специалисты',
  'slots.staffSummary.available': 'Доступно',
  'slots.staffSummary.reserved': 'Зарезервировано',
  'slots.staffSummary.blocked': 'Заблокировано',
  'slots.staffSummary.completed': 'Завершено',
  'slots.staffSummary.specialists': 'Специалисты',
  'slots.staffSummary.devices': 'Устройства',
  'slots.staffSummary.capacityWindows': 'Окна capacity',
  'slots.staffSummary.hardUnavailable': 'Нет capacity',
  'slots.staffSummary.specialistCapacity': 'Capacity специалистов',
  'slots.staffSummary.deviceCapacity': 'Capacity устройств',

  Appointments: 'Записи',
  Slots: 'Слоты',
  Downtime: 'Простой',
  'Reschedule Proposals': 'Предложения переноса',
  'Notification Queue': 'Очередь уведомлений',
  'Device Downtime': 'Простой устройства',
  'Create Appointment': 'Создать запись',
  'Create Device Downtime': 'Создать простой устройства',
  'User Management': 'Управление пользователями',

  'Operational view of current appointments': 'Операционный обзор текущих записей',
  'Operational view of slot inventory': 'Операционный обзор инвентаря слотов',
  'Appointments affected by downtime': 'Записи, затронутые простоем',
  'Outbox and delivery status overview': 'Обзор outbox и статусов доставки',
  'Manual operational creation form': 'Ручная операционная форма создания',
  'Manual maintenance and outage registration': 'Ручная регистрация обслуживания и простоя',
  'Create test users for role and guard validation': 'Создание тестовых пользователей для проверки ролей и guard-правил',

  'Loading appointments...': 'Загрузка записей...',
  'Loading slots...': 'Загрузка слотов...',
  'Loading proposals...': 'Загрузка предложений...',
  'Loading notification queue...': 'Загрузка очереди уведомлений...',
  'Loading downtime items...': 'Загрузка записей простоя...',
  'Loading device downtime...': 'Загрузка простоев устройств...',
  'Loading users...': 'Загрузка пользователей...',
  'Loading profile...': 'Загрузка профиля...',

  'Failed to load appointments': 'Не удалось загрузить записи',
  'Failed to load slots': 'Не удалось загрузить слоты',
  'Failed to load proposals': 'Не удалось загрузить предложения',
  'Failed to load notification queue': 'Не удалось загрузить очередь уведомлений',
  'Failed to load downtime items': 'Не удалось загрузить записи простоя',
  'Failed to load device downtime': 'Не удалось загрузить простои устройств',
  'Failed to load users': 'Не удалось загрузить пользователей',
  'Failed to load profile': 'Не удалось загрузить профиль',

  'No appointments found': 'Записей не найдено',
  'No slots found': 'Слоты не найдены',
  'No proposals found': 'Предложения не найдены',
  'No notification jobs found': 'Задачи уведомлений не найдены',
  'No downtime records found': 'Записи простоя не найдены',
  'No users found': 'Пользователи не найдены',
  'Profile not found': 'Профиль не найден',

  'The appointments list is currently empty.': 'Список записей сейчас пуст.',
  'No slots matched the current filters.': 'По текущим фильтрам слоты не найдены.',
  'No proposals matched the current filters.': 'По текущим фильтрам предложения не найдены.',
  'No notification queue jobs for current filters.': 'Для текущих фильтров задач в очереди нет.',
  'No downtime records for current filters.': 'Для текущих фильтров записей простоя нет.',
  'The slot list is currently empty for the selected filter set.': 'Список слотов пуст для выбранного набора фильтров.',
  'The notification queue is currently empty.': 'Очередь уведомлений сейчас пуста.',
  'The downtime list is currently empty.': 'Список простоев сейчас пуст.',
  'Currently there are no reschedule proposals.': 'Сейчас нет предложений переноса.',
  'Operational view of maintenance and outage windows': 'Операционный обзор окон обслуживания и простоев',
  'No users available for this company yet.': 'Для этой компании пока нет пользователей.',
  Retry: 'Повторить',
  'Load more': 'Загрузить ещё',
  'Loading more...': 'Загрузка ещё...',
  'downtime.pendingApprovals': 'Ожидают одобрения',
  'No client profile is linked to your account yet.': 'К вашей учетной записи пока не привязан клиентский профиль.',
  'My Profile': 'Мой профиль',
  'Personal account information': 'Персональная информация аккаунта',
  'Full Name': 'Полное имя',
  Phone: 'Телефон',
  'Birth Date': 'Дата рождения',
  Notes: 'Заметки',

  Clinic: 'Клиника',
  Client: 'Клиент',
  Procedure: 'Процедура',
  Device: 'Устройство',
  Specialist: 'Специалист',
  'Primary Slot': 'Основной слот',
  'Confirmation Required': 'Требуется подтверждение',
  'Confirmed At': 'Подтверждена в',
  Source: 'Источник',
  Appointment: 'Запись',
  'Old Slot': 'Старый слот',
  'New Slot': 'Новый слот',
  Reason: 'Причина',
  Created: 'Создано',
  'Start Time': 'Время начала',
  'End Time': 'Время конца',
  Role: 'Роль',
  Active: 'Активен',
  Inactive: 'Неактивен',
  'Create user': 'Создать пользователя',
  'role.manager': 'Менеджер',
  'role.technician': 'Техник',
  'role.specialist': 'Специалист',
  'role.reception': 'Ресепшн',
  'role.client': 'Клиент',
  'role.company_admin': 'Администратор компании',
  'role.system_admin': 'Системный администратор'
};

export const TRANSLATIONS: Record<AppLanguage, Record<string, string>> = {
  en,
  ro,
  ru
};
